import { Tooltip } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PropTypes from 'prop-types';
import { React, useEffect, useRef, useState } from "react";
import MaskedInput from 'react-text-mask';
import { getEnvVariable } from '../../../modules/environmentalList';
import DefaultSettings from './settings';
import Typography from '@material-ui/core/Typography';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
    const ref = useRef(null);

    return (
        <MaskedInput
            {...other}
            ref={(input) => {
                ref.current = input ? input.inputElement : null;
                if (inputRef) {
                    inputRef(ref.current);
                }
            }}
            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
            guide={false}
        />
    );
}
TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
};



export default function PhoneFormat(props) {
    const { value, handleFieldValue, extraProps, error, required, shareProps, tooltip, contexthelp, ...otherProps } = props
    const { label, name, helperText, fullWidth, disabled, ...otherConfigs } = otherProps;
    const [currentVal, setCurrentVal] = useState(value)

    useEffect(() => {
        setCurrentVal(value)
    }, [value])
    let tlabel = <Typography variant={value ? 'h6' : 'caption'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
        {tooltip && <Tooltip title={tooltip ? tooltip : null}
            placement="bottom-start" >
            <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        </Tooltip> }
    </Typography>
    return (
        <FormControl fullWidth error={error} >
            <InputLabel shrink={(currentVal || value) ? true : false}>{tlabel}
            </InputLabel>
            <Input
                name={name}
                value={currentVal}
                style={{ fontWeight: 500 }}
                onChange={(evt) => { setCurrentVal(evt.target.value)}}
                id="formatted-text-mask-input"
                //required={required}
                label={tlabel}
                inputComponent={TextMaskCustom}
                InputLabelProps={{
                    shrink: (currentVal || value || disabled) ? true : false,
                }}
                onBlur={() => {
                    handleFieldValue({ target: { value: currentVal, name: name, checked: false }, currentTarget: { dataset: null } })
                }}
                disabled={disabled || false}
            />
            {helperText && <FormHelperText >{helperText}</FormHelperText>}
        </FormControl>
        // <FormControl fullWidth error={error} required={required} >
        //     <InputLabel style={{ fontWeight: 'bold', color: error ? 'red' : 'black' }} shrink> {label}&nbsp; {tooltip && <Tooltip title={tooltip ? tooltip : null}
        //         placement="bottom-start" ><HelpOutlineIcon fontSize="small" style={{ width: '0.8em',color: '#007bff' }} onClick={(evt) => contexthelp ? DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        //     </Tooltip>} </InputLabel>
        //     <Input
        //         name={name}
        //         value={currentVal}
        //         onChange={(evt) => { setCurrentVal(evt.target.value) }}
        //         id="formatted-text-mask-input"
        //         required={required}
        //         inputComponent={TextMaskCustom}
        //         InputLabelProps={{
        //             shrink: true,
        //         }}
        //         onBlur={() => {
        //             handleFieldValue({ target: { value: currentVal, name: name, checked: false }, currentTarget: { dataset: null } })
        //         }}
        //         disabled={disabled || false}
        //     />
        //     {helperText && <FormHelperText >{helperText}</FormHelperText>}
        // </FormControl>
    );
}


// import FormControl from '@material-ui/core/FormControl';
// import FormHelperText from '@material-ui/core/FormHelperText';
// import Input from '@material-ui/core/Input';
// import { Tooltip, Typography } from '@material-ui/core';
// import InputLabel from '@material-ui/core/InputLabel';
// import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// import PropTypes from 'prop-types';
// import React, { useEffect, useState } from "react";
// import MaskedInput from 'react-text-mask';
// import DefaultSettings from './settings';
// import { getEnvVariable } from '../../../modules/environmentalList';
// import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'


// function TextMaskCustom(props) {
//     const { inputRef, ...other } = props;

//     return (
//         <MaskedInput
//             {...other}
//             ref={ref => {
//                 inputRef(ref ? ref.inputElement : null);
//             }}
//             mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
//             placeholderChar={'\u2000'}
//             showMask
//             guide={false}
//         />
//     );
// }

// TextMaskCustom.propTypes = {
//     inputRef: PropTypes.func.isRequired,

// };



// export default function PhoneFormat(props) {
//     const { value, handleFieldValue, extraProps, error, required, shareProps, tooltip, contexthelp, ...otherProps } = props
//     const { label, name, helperText, fullWidth, disabled, ...otherConfigs } = otherProps;
//     const [currentVal, setCurrentVal] = useState(value)
//     // const [value, setValue] = React.useState('')
//     const handleChange = (newValue) => {
//         if (newValue)
//             setCurrentVal(newValue)
//     }

//     const handleBLur = () => {
//         if (matchIsValidTel(currentVal))
//             handleFieldValue({ target: { value: currentVal, name: name, checked: false }, currentTarget: { dataset: null } })
//         else setCurrentVal(null)
//     }
//     useEffect(() => {
//         setCurrentVal(value)
//     }, [value])
//     let tlabel = <Typography variant='subtitle2' color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
//         {tooltip && <Tooltip title={tooltip ? tooltip : null}
//             placement="bottom-start" >
//             <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
//                 onClick={(evt) => contexthelp ?
//                     DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
//         </Tooltip>}
//     </Typography>
//     return (
//         <FormControl error={error}
//         fullWidth={fullWidth ? fullWidth : true}  disabled={disabled || false} required={required} >
//             {/* <InputLabel >{tlabel}</InputLabel> */}
//             <MuiTelInput
//                 name={name}
//                 value={currentVal}
//                 onChange={(e) => { handleChange(e) }}
//                 onBlur={() => handleBLur()}
//                 label={tlabel}
//                 defaultCountry="US" 
               
                
                


//             />
//             {/* <MuiTelInput 
//                 name={name}
//                 value={currentVal}
//                 onChange={(evt) => { setCurrentVal(evt.target.value) }}
//                 id="formatted-text-mask-input"
//                 disabled={disabled || false}
//                // onChange={handleChange}
//                 //required={required}
//                 error={error}
//                 fullWidth={fullWidth ? fullWidth : true}
//                 inputComponent={TextMaskCustom}
//                 label={tlabel}
//                 // InputLabelProps={{
//                 //     shrink: true,
//                 // }}
//                 onBlur={() => {
//                     handleFieldValue({ target: { value: currentVal, name: name, checked: false }, currentTarget: { dataset: null } })
//                 }}
                
//                 //disabled={disabled || false}
//             /> */}
//             {helperText && <FormHelperText >{helperText}</FormHelperText>}
//         </FormControl>
//     );
// }
